import React, { createContext, useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../themes';

export const CustomThemeContext = createContext({
	currentTheme: 'light',
	setTheme: null
});

const CustomThemeProvider = props => {
	const { children } = props;

	// Get current theme from localStorage
	const currentTheme = localStorage.getItem('appTheme') || 'light';

	// State to hold selected theme
	const [ themeName, _setThemeName ] = useState(currentTheme);

	// Retrieve theme object by theme name
	const theme = getTheme(themeName);

	// Apply data-theme attribute for CSS variables
	useEffect(() => {
		document.documentElement.setAttribute('data-theme', themeName);
		document.body.style.backgroundColor = themeName === 'dark' ? '#0f172a' : '#f5f7fb';
		document.body.style.color = themeName === 'dark' ? '#f1f5f9' : '#1e293b';
	}, [themeName]);

	// Wrap _setThemeName to store new theme names in localStorage
	const setThemeName = name => {
		localStorage.setItem('appTheme', name);
		_setThemeName(name);
	};

	const contextValue = {
		currentTheme: themeName,
		setTheme: setThemeName
	};

	return (
		<CustomThemeContext.Provider value={contextValue}>
			<ThemeProvider theme={theme}>{children}</ThemeProvider>
		</CustomThemeContext.Provider>
	);
};

export default CustomThemeProvider;